import { captureException } from '@sentry/react';

import { APP_BASE_URL } from '../constants.js';

/**
 * Get the link to the patient details page.
 * Fallback to '#' if we don't have enough info to build the link.
 */
export const getPatientLink = (userId?: string, shouldHideEmailComponentFallback?: boolean) => {
  if (!APP_BASE_URL || !userId) {
    captureException(new Error('[getPatientLink] Missing required patient information'), {
      tags: { issueIn: 'getPatientLink' },
      extra: { userId, APP_BASE_URL },
    });

    // NOTE: Return null to hide the email component fallback.
    // Make sure the email templates explicitly handle this case
    // using {{#if patientLink}} ... {{/if}}.
    // If not defined then we fallback to '#'
    return shouldHideEmailComponentFallback ? null : '#';
  }

  return `${APP_BASE_URL}/patients/${userId}`;
};
